import React, { ReactNode } from 'react';

import { Stack, Box, HStack, Input } from '@chakra-ui/react';

import { textFieldStyles } from 'components/DataEntry';
import {
  CheckmarkCircleOutlineIcon,
  CloseCircleOutlineIcon,
} from 'components/index';

export interface Props {
  confirmationText: string;
  placeholder?: string;
  label: ReactNode;
  command: string;
  setCommand: (val: string) => void;
  inputWidth?: string | number;
  inputRef?: React.RefObject<HTMLInputElement>;
  onKeyDown?: React.KeyboardEventHandler<HTMLInputElement>;
  paddingTop?: string | number;
}

export const ConfirmationInput = (props: Props) => {
  const {
    confirmationText,
    placeholder,
    label,
    command,
    setCommand,
    inputWidth = 80,
    inputRef,
    onKeyDown,
    paddingTop = 2,
  } = props;

  return (
    <Stack pt={paddingTop}>
      <Box>{label}</Box>
      <HStack>
        <Box w={inputWidth}>
          <Input
            placeholder={placeholder ?? confirmationText}
            onChange={e => setCommand(e.target.value)}
            onKeyDown={onKeyDown}
            value={command}
            ref={inputRef}
            autoFocus
            color={
              !!command
                ? command.trim().toLowerCase() ===
                  confirmationText?.trim().toLowerCase()
                  ? 'green'
                  : 'red'
                : 'inherit'
            }
            {...textFieldStyles?.input}
          />
        </Box>
        <Box w={6}>
          {command === '' ? (
            <Box />
          ) : command.trim().toLowerCase() ===
            confirmationText?.trim().toLowerCase() ? (
            <CheckmarkCircleOutlineIcon color="green" />
          ) : (
            <CloseCircleOutlineIcon color="red" />
          )}
        </Box>
      </HStack>
    </Stack>
  );
};
